import { useEffect, useState } from "react";

const loadLottieScript = (setIsLoaded: (status: boolean) => void) => {
  if (document.getElementById("lottie-script")) {
    setIsLoaded(true);
    return;
  }

  const script = document.createElement("script");
  script.id = "lottie-script";
  script.src = "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.9.6/lottie.min.js";
  script.async = true;
  script.onload = () => setIsLoaded(true);

  document.body.appendChild(script);
};

const useLottieLoader = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (document.readyState === "complete") {
      loadLottieScript(setIsLoaded);
    } else {
      const onLoad = () => loadLottieScript(setIsLoaded);
      window.addEventListener("load", onLoad);

      return () => window.removeEventListener("load", onLoad);
    }
  }, []);

  return isLoaded;
};

export default useLottieLoader;